import React from "react";
import { FormattedMessage, injectIntl } from "@irati/utils/lang";
import Flex from "@irati/ui/src/Flex";
import Button from "@irati/ui/src/Button";
import { H3 } from "@irati/ui/src/Headings";
import { PageHeader, TitleAndCount } from "./styled";
var HasBenefitsHeader = function (props) {
    var onAdd = props.onAdd, minimalView = props.minimalView, total = props.total, formatMessage = props.formatMessage;
    return (React.createElement(PageHeader, null,
        React.createElement(Flex, { direction: minimalView ? "row-reverse" : "row", justifyContent: "space-between", margin: "0 15px 0", alignItems: "center" },
            !minimalView && (React.createElement(TitleAndCount, { title: formatMessage({ id: "admin.components.companyBenefitsList.styledNameCountAndButton.title" }), count: formatMessage({ id: "admin.components.companyBenefitsList.styledNameCountAndButton.count" }, { total: total }) })),
            React.createElement(Button, { primary: true, onClick: onAdd },
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsList.styledNameCountAndButton.buttonText" })),
            minimalView && (React.createElement(H3, null,
                React.createElement(FormattedMessage, { id: "admin.components.companyBenefitsList.minimalView.title" }))))));
};
export default injectIntl(HasBenefitsHeader);
